import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';
import { I18N, I18NContext, GlobalContext } from 'commons';
import { Link } from '@reach/router';

export default function ItemHeader({ type, notificationObj, currentTimeInResponse, event }) {
  const i18n = useContext(I18NContext);
  const { lang } = useContext(GlobalContext);
  const getPeriodText = (startTime, endTime, tz) => {
    let l = 'en';
    switch (lang.toLowerCase()) {
      case 'no_no':
        l = 'nb';
        break;
      case 'ht_ht':
        l = 'en';
        break;
      default:
        l = lang.toLowerCase();
    }
    moment.locale(l);
    const timeZone = tz || 0;
    const start = moment.tz(startTime, timeZone);
    return start.format('LLLL z');
  };

  const isExpired = (start, end, expireTime) => {
    const sub = end - start;
    const expire = parseInt(expireTime, 10);
    return sub && !Number.isNaN(sub) && expireTime &&
      !Number.isNaN(expire) && sub > 1000 * 60 * 60 * expire;
  };

  return (
    <div className="row notification-title mx-0">
      <div className="col-12 p-0">
        <h1 className="eventtile">
          <span id={`notification_title_${notificationObj.notificationId}`}>
            {notificationObj.title}
          </span>
          {
            notificationObj.attachmentFiles.length > 0 && type !== 'detail' &&
            <Link
              to={`${notificationObj.notificationId}?event_id=${event.id}`}
              eb-test="eventSubscription.event.attachment.link"
              aria-label={`${notificationObj.attachmentFiles.length} ${i18n.get('eventSubscription.notification.field.attachment')}`}
            >
              <i className="attachment-icon fas fa-paperclip" />
            </Link>
          }
        </h1>
      </div>
      <div className="col-lg-4 alert-level p-0">
        <label
          className={
            classnames('text-center color-box', {
              'btn-success': notificationObj.type !== 2 &&
                notificationObj.type !== 3,
              'btn-danger': notificationObj.type === 2,
              'btn-warning': notificationObj.type === 3
            })
          }
          id={`event_level_label_${notificationObj.notificationId}`}
        >
          {
            notificationObj.type !== 2 && notificationObj.type !== 3 &&
          <span className="notification-label">
            <I18N>eventSubscription.notification.field.type.community</I18N>
          </span>
          }
          {
            notificationObj.type === 2 &&
          <span>
            <I18N>eventSubscription.notification.field.type.alert</I18N>
          </span>
          }
          {
            notificationObj.type === 3 &&
          <span className="notification-label">
            <I18N>eventSubscription.notification.field.type.advisory</I18N>
          </span>
          }
        </label>
      </div>
      <div className="sub-title col-lg-8 pl-lg-4" id={`notification_date_${notificationObj.notificationId}`}>
          <small>
            {getPeriodText(notificationObj.notificationSendDate,
              currentTimeInResponse, notificationObj.timeZone)}
          </small>
          {
            isExpired(notificationObj.notificationSendDate,
              currentTimeInResponse, notificationObj.expire) &&
              <small className="text-danger">
                <I18N>eventSubscription.notification.message.expired</I18N>
              </small>
          }
        </div>
    </div>
  );
}

ItemHeader.propTypes = {
  type: PropTypes.string.isRequired,
  notificationObj: PropTypes.shape().isRequired,
  currentTimeInResponse: PropTypes.number,
  event: PropTypes.shape()
};

ItemHeader.defaultProps = {
  currentTimeInResponse: null,
  event: {}
};
